<template>
<div class="field file-padded-bottom-border" style="padding-bottom: 1.5rem;">
	<div class="control">
			<div class="columns">
					<div class="column is-6">
						<label>Please click on this button below to complete your form online.</label>
            <div>
              <button v-if="complianceId == 22 || complianceId == 23 || complianceId == 25 || complianceId == 36 || complianceId == 72" class="pandadoc-button button" @click="showFormModal" :class="{ 'is-loading': isLoading }">
                Declination Form
              </button>
              <button v-else class="pandadoc-button button" @click="showFormModal" :class="{ 'is-loading': isLoading }">
                <span>Complete&nbsp;</span><span class="btn-item-name">{{ removeAsterisk(itemName) }}</span><span>&nbsp;Form Online</span>
              </button>
            </div>
					</div>
			</div>
	</div>
</div>
</template>
<script>
export default {
  props: {
    itemName: {
      type: String,
      default: 'Form'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    complianceId: {
      type: Number,
      default: null
    }
  },
  methods: {
    removeAsterisk: function(value) {
      if(!value) return "";
      value = value.replace("*", "");
      return value;
    },
    showFormModal(){
      VueStore.dispatch('signature/setVariable', { key: 'loader', value: true });
      VueStore.dispatch('signature/generatePandaForm');
      // VueStore.dispatch('notify/setVariable', { key: 'viewCompleteOnlineFormModal', value: true });
    }
  }
}
</script>
<style scoped>
.pandadoc-button{
    color: #FFF;
    font-weight: bold;
    background-color: #3273dc;
    border: 1px solid #3273dc;
    font-size: 14px !important;
    font-weight: 600;
    letter-spacing: .25px;
    border-radius: 3px;
    transition: 0.3s;
    height: 2.25em !important;
    padding: 2px 8px !important;
    margin: 24px 0px;
    max-width: 100%;
}

/* The item name shrinks (min-width: 0) while "Complete" and "Form Online"
   stay visible, so long names truncate as "Complete ... Form Online". */
.btn-item-name{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    flex: 0 1 auto;
}

.pandadoc-button:hover{
    background-color: #4f8ff5 !important;
    color: #ffffff !important;
    border: 1px solid #3273dc !important;
}

</style>
